import React from 'react'
import { Box } from '@mui/system'
import { useTheme } from '@mui/material'
import { ALPHABET } from '../../../../utils/constants'

interface Props {
    answer: any
    selected: boolean
    index: number
    handleSelect: (item: any) => void
}

const Option: React.FC<Props> = ({ answer, selected, index, handleSelect }) => {
    const theme = useTheme()

    const styles = {
        wrapper: {
            display: 'flex',
            alignItems: 'start',
            cursor: 'pointer',
            mb: 1,
        },
        answerLetter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            mr: 1,
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: selected ? '#EFF3FB' : '#fff',
            border: selected
                ? '1px solid #4257B2'
                : `1px solid ${theme.palette.grey[200]}`,
        },
        answerText: {
            display: 'flex',
            alignItems: 'center',
            width: '90%',
            minHeight: '24px',
            p: 1,
            background: selected ? '#EFF3FB' : '#fff',
            borderRadius: '8px',
            border: selected
                ? '1px solid #4257B2'
                : `1px solid ${theme.palette.grey[200]}`,
        },
    }

    return (
        <Box
            sx={styles.wrapper}
            onClick={handleSelect}
        >
            <Box sx={styles.answerLetter}>{ALPHABET[index].name}</Box>

            <Box sx={styles.answerText}>
                <div
                    dangerouslySetInnerHTML={{ __html: answer.content }}
                    style={{
                        wordBreak: 'break-all',
                    }}
                />
            </Box>
        </Box>
    )
}

export default Option
